import React from "react";
import { FaBell } from "react-icons/fa";
import { Menu, Dropdown, message } from "antd";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import AuthService from "../session/AuthService";

export default function TopBar({ collapsed, onToggle }) {
  const isMobile = window.innerWidth <= 768;
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    message.success("Logged out successfully!");
    navigate("/login");
  };

  const menu = (
    <Menu>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          className="sidebar-toggle-btn"
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          onClick={onToggle}
          style={{ opacity: isMobile ? 0 : 1 }}
        >
          {collapsed ? "»" : "«"}
        </button>

        <input
          className="topbar-search"
          placeholder="Search users, transactions..."
          aria-label="Search users, transactions"
        />
      </div>

      <div
        className="topbar-right"
        style={{ display: "flex", alignItems: "center" }}
      >
        <button className="topbar-bell" title="Notifications">
          <FaBell />
        </button>

        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <span
            className="topbar-avatar"
            style={{ cursor: "pointer", marginLeft: 16, userSelect: "none" }}
            title="User menu"
          >
            {(() => {
              const fullName = AuthService.getName() || "";
              const initials = fullName
                .trim()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase())
                .join("");
              return initials;
            })()}
          </span>
        </Dropdown>
      </div>
    </header>
  );
}
